import t from "styled-components";
import { SkeletonShared as i } from "./atoms-v21000.js";
import { Base as a } from "./atoms-v2777.js";
const n = t.picture`
  ${a}

  aspect-ratio: ${({ $aspectRatio: e }) => e};
  display: flex;
`, c = t.img`
  aspect-ratio: ${({ $aspectRatio: e }) => e};
  block-size: auto;

  /* Ensure images aren’t affected by line-height, which adds extra space below the image. */
  display: block;
  line-height: 3;

  /* Make sure the image adheres to the parent container’s size. */
  max-inline-size: 100%;
  min-height: 100%;
  min-width: 100%;

  /* Image should always fill the available white-space, even when it means cropping the image. */
  object-fit: cover;
  object-position: center;
  text-align: center;
`, l = t(i)`
  aspect-ratio: ${({ $aspectRatio: e }) => e};
  display: block;
`;
export {
  c as Img,
  n as Picture,
  l as PictureSkeleton
};
